/**
 * Helper class containing parse functions.
 *
 * @class
 *
 **/
class BonusParser {
    static parse(cfg, settings, options) {

        const isBonusAllowed = !options.isDemo && !options.isScratch && !options.isNsg && !options.isTap && !(options.isRTG && options.isTable) && cfg.bridge.provider !== 'evolution';

        if (!cfg.bridge.inReview) {
            cfg.bonus = {
                enabled: isBonusAllowed,
                provider: cfg.bridge.provider,
                basePath: `${cfg.game.preconfig.cdn}../../widgets/bonus/`,
                cdnPath: `${cfg.game.preconfig.cdn}../../../`,
                assetsPath: `${cfg.game.preconfig.cdn}../../assets/`,
            };
            if (isBonusAllowed) { // Enable Widget only for Vue Bonus
                cfg.widgets.enabled = true;
            }
        }

        cfg.bonus = {
            ...cfg.bonus,
            hasTurboMode: cfg.bars.options.hasTurboMode,
            hasGamble: cfg.gamble && cfg.gamble.enabled,
            isBlackJack: options.isBlackJack,
            timestamp: cfg.bridge.timestamp,
            gameId: cfg.server.launchParams.gameId,
            hasBonusLinks: Boolean(cfg.bars.options.hasBonusLinks === true),
            hasFeatureBuy: cfg.bars.options.hasFeatureBuy
        };

        return cfg.bonus;
    }

    static parseWheel(cfg) {
        if (!cfg.bonusWheel) {
            cfg.bonusWheel = {
                cdn: cfg.game.preconfig.cdn,
                basePath: '../../scenes/bonus-wheels/bonus-wheel/',
                skin: 'bonus-wheel',
                enabled: true,
            };
        }

        return cfg.bonusWheel;
    }

}


module.exports = BonusParser;
